<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVO','UTENTE'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="utente" autocomplete="off">
            <vs-row>
              <vs-col >
                <label class="vs-input--label">Nome</label>
                <vs-input class="w-full" v-model="nome" name="nome" placeholder="Inserisci il nome dell'utente..." v-validate="'required|min:5'" />
                <span class="text-danger text-sm" v-show="errors.has('utente.nome')">{{ errors.first('utente.nome') }}</span>
              </vs-col>
              <vs-col class="mt-2">
                <label class="vs-input--label">Cognome</label>
                <vs-input class="w-full" v-model="cognome" name="cognome" placeholder="Inserisci il cognome dell'utente..." v-validate="'min:2'" />
                <span class="text-danger text-sm" v-show="errors.has('utente.cognome')">{{ errors.first('utente.cognome') }}</span>
              </vs-col>
              <vs-col class="mt-2">
                <label class="vs-input--label">Email (login)</label>
                <vs-input class="w-full" name="email" v-model="email" autocomplete="false" placeholder="Inserisci l'indirzzo mail che servirà come username..." v-validate="'required|email'" />
                <span class="text-danger text-sm" v-show="errors.has('utente.email')">{{ errors.first('utente.email') }}</span>
              </vs-col>
                <vs-col class="mt-2">
                  <label class="vs-input--label">Telefono</label>
                  <VuePhoneNumberInput color="#7367f0" clearable :translations="phoneTranslation" no-country-selector v-model="telefono" name="telefono" class="is-label-placeholder w-full"/>
              </vs-col>
              <vs-col class="mt-2">
                <label class="vs-input--label">Tipo Utente</label>
                <v-select name="permessi" placeholder="Scegli il tipo di utente..." :options="decodePermessi.map( e => e.label)" v-model="string_permesso" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm" v-show="errors.has('utente.permessi')">{{ errors.first('utente.permessi') }}</span>
              </vs-col>
              <vs-col class="mt-2">
                <label class="vs-input--label">Password</label>
                <vs-input class="w-full" name="password" v-model="password" autocomplete="false" :placeholder="this.selected ? 'Inserire una nuova password per modificarla' : 'Password (generata)'" v-validate=" (!id ? 'required|' : '') + 'min:8|max:64|is_password'" />
                <span class="text-danger text-sm" v-show="errors.has('utente.password')">{{ errors.first('utente.password') }}</span>
                <div id="pw_err" class="scadenza_red text-center" style="color:white;"></div>
              </vs-col>
              <vs-col class="mt-2">
                <label class="vs-input--label">Responsabile</label>
                <v-select name="resp" placeholder="Scegli il Responsabile..." :options="responsabili" v-model="resp" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
              </vs-col>
            </vs-row>
            <vs-row v-if="this.string_permesso != 'Utente' && b_usrs.length" class="mt-4">
              <vs-col>
                <label class="vs-input--label" style="color: orange;">Lista Utenti di cui Resp.</label>
                <div v-for="(u,idx) in b_usrs" :key="idx" class="my-2 mx-4">
                  <label>{{[u.cognome,u.nome].join(' ')}}</label>
                </div>
              </vs-col>
            </vs-row>
            <!-- <vs-row v-if="this.string_permesso == 'Admin'" class="mt-4">
              <vs-col v-for="(key, value) in Object.entries(deep_settings)" :key="key">
                <label class="vs-input--label" style="color: orange;">{{key}}</label>
              </vs-col>
            </vs-row> -->
          </form>
        </div>
        <vs-row slot="footer" class="mb-3 mt-3">
          <vs-divider />
          <vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-button v-if="this.id" @click="eliminaUtente($event)" :disabled="!$acl.check('admin')" type="line" color="danger" icon-pack="feather" icon="icon-trash">Elimina</vs-button>
            <vs-button class="ml-6" :disabled="this.checkDis()" @click="salvaUtente($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'

// For custom error message
import { Validator } from 'vee-validate';

// vue-select
import vSelect from 'vue-select'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

const dict = {
  utente: {
    nome: {
      required: 'Nome è un campo obbligatorio',
      min: 'Inserire almeno 5 caratteri'
    },
    cognome: {
      min: 'Inserire almeno 2 caratteri'
    },
    email: {
      required: 'Email è un campo obbligatorio',
      email: 'Inserire un indirizzo email valido',
    },
    password: {
      required: 'Inserire una password',
      max: 'Inserire massimo 64 caratteri',
      min: 'Inserire almeno 8 caratteri',
      is_password: 'Almeno un simbolo, una maiuscola e un numero'
    },
    permessi: {
      required: 'Specificare i permessi per l\'utente'
    },
  }
};

// register custom messages
Validator.localize('it', dict);
function isPW(pw)
{
	if( pw == '' ) { return true }
  var upper = pw.match(/[A-Z]/g)
  var num = pw.match(/[0-9]/g)
  var symb = pw.match(/[!@#$€£%^&*(),.?"=\-'_:{}[\]|<>]/g)
	if( upper && num && symb ) {
		return true
  }
	return false
}

Validator.extend('is_password', isPW);

export default {
  data() {
    return {
      // utente
      id: null,
      nome: "",
      cognome: "",
      email: "",
      telefono: "",
      permessi: null,
      password: "",
      decodePermessi: [{
                        label: 'Admin',
                        value: 0},{
                        label: 'Responsabile',
                        value: 1},{
                        label: 'Utente',
                        value: 2}],
      string_permesso: "",

      phoneTranslation: {
        countrySelectorLabel: 'Paese',
        countrySelectorError: 'Scegliere un paese',
        phoneNumberLabel: 'Numero di telefono',
        example: 'Esempio :'
      },
      responsabili: [],
      resp: null,
      b_usrs: [],
    }
  },

  props: {
    selected: Object
  },

  mounted() {
    this.getResponsabili()
    if (this.selected && this.selected.id) this.getUtentiBacino()
    if(this.selected) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      this.string_permesso = this.decodePermessi.find( e => e.value == this.permessi).label
      this.deep_settings = this.deep_settings ? JSON.parse(this.deep_settings) : {}
    } else {
      this.password = this.genPassword(8)
    }
    this.$watch('password', (val) => {
      if (val.length > 7) {
        document.getElementById("pw_err").innerText = ''
        if (val.includes(this.nome.toLowerCase()) || val.includes(this.cognome.toLowerCase())) {
          document.getElementById("pw_err").innerText = 'La password non può contenere nome e/o cognome'
        }
      }
    });
  },

  methods: {
    buildSaveObject() {
      let obj = {
        nome: this.nome,
        cognome: this.cognome ? this.cognome : '',
        email: this.email,
        telefono: this.telefono ? this.telefono : '',
        permessi: this.decodePermessi.find( e => e.label == this.string_permesso).value,
        id_responsabile: this.resp ? this.resp.id : null,
        deep_settings: this.deep_settings
      }

      if(this.password && this.password.length) {
        obj['password'] = this.password
      }

      if(this.id) {
        obj['id'] = this.id
      }
      return obj
    },
    salvaUtente(ev) {
      this.validateUtente().then(() => {
        let action = this.id ? 'modifica' : 'crea'
        let obj = this.buildSaveObject()
        for (let [key, value] of Object.entries(obj)) {
          if (typeof value === 'string' || value instanceof String) {
            var patt1 = /[^0-9]/;
            if ( value.charAt(0).match(patt1) && key != 'codice_fiscale' && key.substring(0,5) != 'email' ) {
              obj[key] = value.charAt(0).toUpperCase() + value.slice(1)
            }
          }
        }
        if (obj['password']) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/utente/check_pw', obj, {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
          })
          .then(res => {
            document.getElementById("pw_err").innerText = ''
            if (res.data == 500) {
              document.getElementById("pw_err").innerText = 'La password non può essere uguale ad una precedente'
            } else {
              axios.post(process.env.VUE_APP_BACKEND_API+'/utente/' + action, obj, {
                  headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                  withCredentials: true,
              })
              .then(res => {
                  this.$emit('utente-salvato')
                  ev.stopPropagation()
              }).catch(e => console.log(e))
            }
          })
        } else {
          axios.post(process.env.VUE_APP_BACKEND_API+'/utente/' + action, obj, {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
          })
          .then(res => {
              this.$emit('utente-salvato')
              ev.stopPropagation()
          }).catch(e => console.log(e))
        }
      })
    },
    validateUtente() {
      console.log('VALIDATE UTENTE');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('utente').then(result => {
          if (result) {
            console.log('success');
            resolve(true)
          } else {
            console.log('failed');
            // this.$vs.notify({
            //   color: 'warning',
            //   time: 4000,
            //   title: 'Validazione',
            //   text: this.errors,
            //   icon:'mail'
            // })
            reject("correct all values");
          }
        })
      })
    },
    eliminaUtente(ev) {
      this.$emit('elimina-utente')
      ev.stopPropagation()
    },
    genPassword(l) {
      let result = ''
      let bool = false
      while (!bool) {
        result = Math.random().toString(36).slice(-l)
        for (var i = 0; i < result.length; i++) {
          if (!isNaN(result[i])) {
            bool = true
            break
          }
        }
      }
      bool = false
      let pos = 0
      while (!bool) {
        pos = Math.floor(Math.random() * result.length)
        if (isNaN(result.charAt(pos))) {
          result = result.substring(0, pos) + result.charAt(pos).toUpperCase() + result.substring(pos+1, result.length);
          bool = true
        }
      }
      bool = false
      while (!bool) {
        let pos2 = Math.floor(Math.random() * result.length)
        let special = "._:,#$-]"
        if (pos != pos2) {
          result = result.substring(0, pos2) + special[pos2] + result.substring(pos2+1, result.length);
          bool = true
        }
      }
      return result;
    },
    checkDis() {
      return (document.getElementById("pw_err") && document.getElementById("pw_err").innerText.length) ? true : false
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    getResponsabili() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/utente/get_responsabili',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.responsabili = response.data.map(e => {
                                  e['label'] = `${e['cognome']}`+' '+`${e['nome']}`
                                  return e
                                })
        if (this.selected && this.selected.id_responsabile) {
          this.resp = this.responsabili.find(r => r.id == this.selected.id_responsabile)
        }
      }).catch(e => console.log(e))
    },
    getUtentiBacino() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/utente/bacino_utenti', {target_id: this.selected.id},
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.b_usrs = response.data
      }).catch(e => console.log(e))
    },
  },
  components: {
    vSelect,
    VuePhoneNumberInput
  }
}
</script>
